import { getTotalNumberOfAccountUsers } from 'pricing-pages-lib/utils/seatsInventoryUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchSeatsInventoryRequestTypes } from '../actions/SeatsInventoryActions';
import { makeRequestStatusSelector } from './RequestStatusSelectors';
import { transformState } from './SelectorUtils';
export const fetchSeatsInventoryStatus = makeRequestStatusSelector(FetchSeatsInventoryRequestTypes.REQUEST);
export const totalNumberOfAccountUsersSelector = createSelectorFromUtil(getTotalNumberOfAccountUsers, transformState);